import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Sparkles, ArrowRight, Rocket } from 'lucide-react';
import { CHANGELOG } from '../config/changelog';
import { useNavigate } from 'react-router-dom';

const WhatsNewModal = ({ open, onOpenChange }) => {
  const navigate = useNavigate();

  const handleExplore = (path) => {
    onOpenChange(false);
    if (path) setTimeout(() => navigate(path), 150);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[85vh] overflow-hidden p-0 gap-0" data-testid="whats-new-modal">
        <DialogHeader className="p-6 pb-4 border-b border-slate-100 dark:border-slate-800 bg-emerald-50 bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-emerald-950/40 dark:to-teal-950/40">
          <DialogTitle className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-emerald-500 bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center shadow-md shadow-emerald-500/30">
              <Rocket className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="text-lg font-semibold text-slate-900 dark:text-white">What's new at CARTIEAI</p>
              <p className="text-xs text-slate-400 font-normal mt-0.5">Latest shipped features and improvements</p>
            </div>
          </DialogTitle>
        </DialogHeader>

        <div className="p-6 overflow-y-auto max-h-[65vh] space-y-6" data-testid="whats-new-list">
          {CHANGELOG.map((release, idx) => (
            <div key={release.version} className="relative">
              {idx === 0 && (
                <span className="absolute -top-2 -right-1 px-2 py-0.5 text-[11px] font-bold bg-emerald-500 text-white rounded-full shadow-md">
                  LATEST
                </span>
              )}
              <div className="flex items-center gap-2 mb-2">
                <Sparkles className="w-3.5 h-3.5 text-emerald-500" />
                <p className="text-xs font-medium text-slate-400 uppercase tracking-wider">{release.date}</p>
              </div>
              <h3 className="font-semibold text-slate-900 dark:text-white">{release.title}</h3>
              <p className="text-xs text-emerald-600 dark:text-emerald-400 font-medium mb-3">{release.highlight}</p>
              <ul className="space-y-2">
                {release.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 p-2.5 rounded-lg bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700/50">
                    <span className="text-base mt-0.5" aria-hidden>{item.emoji}</span>
                    <p className="text-sm text-slate-700 dark:text-slate-300 leading-relaxed">{item.text}</p>
                  </li>
                ))}
              </ul>
              {idx < CHANGELOG.length - 1 && <div className="mt-5 pt-0 border-t border-slate-100 dark:border-slate-800" />}
            </div>
          ))}
        </div>

        <div className="px-6 py-3 border-t border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900 flex items-center justify-between">
          <p className="text-xs text-slate-400">
            Have an idea?{' '}
            <a href="mailto:hello@cartieai.com" className="text-emerald-600 hover:underline font-medium">
              Tell us
            </a>
          </p>
          <Button
            size="sm"
            onClick={() => handleExplore('/cloud-audit')}
            className="bg-emerald-500 bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white"
            data-testid="whats-new-cta"
          >
            Try Free Cloud Audit
            <ArrowRight className="w-3.5 h-3.5 ml-1.5" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WhatsNewModal;
